/*
 * <brand-product-conditionals>
 * Toggles leather-service UI as the shopper changes variants:
 *   - covered-back mail-in panel (Service Type = "Covered Back (Mail-In)")
 *   - a "Bundle — save $25" badge (covered back + upgraded side bars)
 *   - a mail-in line-item property that only attaches to the order for covered-back variants
 *
 * Reads a per-variant JSON map rendered by the brand_covered_back block, and listens to
 * Dawn's standard `variant-change` pub/sub event (published by product-info.js). Safe on any
 * product: if the product has no Service Type option, the block isn't rendered at all, and if
 * no covered-back variant is selected every conditional stays hidden/disabled.
 */
if (!customElements.get('brand-product-conditionals')) {
  customElements.define(
    'brand-product-conditionals',
    class BrandProductConditionals extends HTMLElement {
      constructor() {
        super();
        this.section = this.dataset.section;
        this.variants = {};
        const dataEl = this.querySelector('[data-conditional-data]');
        if (dataEl) {
          try {
            this.variants = JSON.parse(dataEl.textContent);
          } catch (e) {
            this.variants = {};
          }
        }
        this.panel = this.querySelector('[data-covered-back-panel]');
        this.badge = this.querySelector('[data-bundle-badge]');
        this.noteInput = this.querySelector('[data-mailin-note]');
      }

      connectedCallback() {
        // Initial state from the server-selected variant.
        this.update(this.dataset.initialVariant);

        // React to variant changes. `subscribe`/`PUB_SUB_EVENTS` are Dawn globals.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || event.data.sectionId !== this.section) return;
            this.update(event.data.variant ? event.data.variant.id : null);
          });
        }
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
      }

      update(variantId) {
        const entry = variantId != null ? this.variants[String(variantId)] : null;
        const isCoveredBack = !!(entry && entry.cb);
        const isBundle = !!(entry && entry.bundle);

        if (this.panel) this.panel.hidden = !isCoveredBack;
        if (this.badge) this.badge.hidden = !isBundle;
        // A disabled input is not submitted with the form, so the note only rides along
        // with covered-back (mail-in) orders.
        if (this.noteInput) this.noteInput.disabled = !isCoveredBack;
      }
    }
  );
}
